import React from "react";
import MessageCardView from "./MessageCardView";
import MessageTableView from "./MessageTableView";

const MessageList = ({ 
  messages, 
  viewType, 
  currentPage, 
  totalPages, 
  onEdit, 
  onDelete, 
  onPageChange,
  onAddMessage 
}) => {
  const props = {
    messages,
    currentPage,
    totalPages,
    onEdit,
    onDelete,
    onPageChange,
    onAddMessage
  };

  return viewType === "card" ? (
    <MessageCardView {...props} />
  ) : (
    <MessageTableView {...props} />
  );
};

export default MessageList; 